import type { MouseEventHandler } from "react";
import type { TIconKey } from "@/ui/components/primitives/Icon";
import type { TWithDataComponent } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_LIFESTYLE_CARD_ARTICLE_CLASS =
  "w-full rounded-sys-sm border border-component-card-base p-4 shadow-sm shadow-sys-outline-dark";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatLifestyleCardCat = {
  name: string;
  weight: string;
  bodyType: string;
  lifestyle: string;
  calories: number;
};

export type TCatLifestyleCardProps = TWithDataComponent & {
  cat: TCatLifestyleCardCat;
  calorieDescription: string;
  alert?: string;
  onEditHealth: MouseEventHandler<HTMLButtonElement>;
  onEditCalories: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardCaloriesSectionProps = {
  calories: string;
  description: string;
  alert?: string;
  title: string;
  editCopy: string;
  editAriaLabel: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardHealthSectionProps = {
  healthStats: TCatLifestyleCardHealthStat[];
  title: string;
  editCopy: string;
  editAriaLabel: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardHealthStat = {
  icon: TIconKey;
  label: string;
  value: string;
};

export type TUseCatLifestyleCard = {
  healthStats: TCatLifestyleCardHealthStat[];
  healthTitle: string;
  portionSizeTitle: string;
  dailyCalories: string;
  editCopy: string;
  editHealthAriaLabel: string;
  editCaloriesAriaLabel: string;
};

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const CAT_LIFESTYLE_CARD_DEFAULTS = {
  "data-component": "CatLifestyleCard",
} as const;
